module.exports = "https://lijc.rightinthebox.com/promotion_src/public/optimus-eechic/_next/static/images/pc_cart_empty_CeNLE.png";